import { Badge, ButtonProps, IconButton, Tooltip } from '@mui/material';

interface SquareButtonProps extends ButtonProps {
  icon: React.ReactElement;
  disabled?: boolean;
  loading?: boolean;
  withBadge?: boolean;
  badgeContent?: number;
  tooltip?: string;
  keepColor?: boolean;
  'data-testid'?: string;
}

const customStylesHandler = (keepColor: boolean, color: string) => ({
  button: {
    padding: '4px',
    borderRadius: '8px',
    border: '2px solid',
    borderColor: keepColor ? `${color}.main` : '#D1D4D9',
    background: '#FFFFFF',
    '& :focus': {
      borderRadius: '8px',
    },
    '& :hover': {
      borderRadius: '8px',
    },
  },
  badge: {
    '& .MuiBadge-badge': {
      minWidth: '18px',
      height: '18px',
    },
  },
});

// A square button with an icon and no text
export function SquareButton({
  icon,
  onClick,
  disabled = false,
  loading = false,
  withBadge = false,
  badgeContent = 0,
  tooltip = '',
  keepColor = false,
  color = 'primary',
  'data-testid': dataTestId,
}: SquareButtonProps) {
  const customStyles = customStylesHandler(keepColor, color);
  return (
    <Badge
      badgeContent={badgeContent}
      color={'error'}
      sx={customStyles.badge}
      invisible={!withBadge}
    >
      <Tooltip
        title={tooltip}
        arrow
        placement='bottom'
      >
        <IconButton
          color={'default'}
          onClick={onClick}
          sx={customStyles.button}
          disabled={disabled || loading}
          data-testid={dataTestId}
        >
          {icon}
        </IconButton>
      </Tooltip>
    </Badge>
  );
}
